<ng-container *ngIf="patient$ | async as patient; else noPatient">
  <pr-patient-profile-summary
    class="m-4 block"
    [patient]="patient"
    [actions]="patientActions"
    [expandable]="true"
  >
    <div>
      <pr-patient-last-visit [patient]="patient" />

      <div
        *ngIf="nextScheduledAppointment$ | async as nextScheduledAppointment"
      >
        <strong>Next Visit: </strong>
        <pr-formatted-event-field
          *ngIf="nextScheduledAppointment.event"
          field="from"
          [event]="nextScheduledAppointment.event"
          [format]="dateFormat"
        />
      </div>

      <ng-container *ngIf="appointment$ | async as appointment">
        <div *ngIf="appointment.event; else noEvent">
          <strong>Appointment: </strong>
          <pr-formatted-event-field
            field="from"
            [event]="appointment.event"
            [format]="dateService.format.dateWithTimes"
          />
        </div>
      </ng-container>

      <ng-template #noEvent>
        <div><strong>Appointment: </strong>Unscheduled</div>
      </ng-template>

      <pr-patient-fee-schedule [feeSchedule]="patient.preferredFeeSchedule" />
    </div>

    <pr-appointment-tags-sidebar-list
      *ngIf="hasAppointmentTags$ | async"
      [appointment]="appointment$ | async"
    />
  </pr-patient-profile-summary>

  <mat-divider />

  <pr-patient-medical-alerts class="m-4 block" [patient]="patient" />
</ng-container>

<ng-template #noPatient>
  <div class="h-14"></div>
</ng-template>
